import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../firebase/AuthContext';

const PrivateRoute = () => {
  const { currentUser } = useAuth();
  
  // If user is not authenticated, redirect to login
  if (!currentUser) {
    return <Navigate to="/login" />;
  }
  
  // If user is authenticated, render the child routes
  return <Outlet />;
};

export default PrivateRoute;
